module.exports = {
  FreeResponse: {
    PluginName: "Free Response",
    content_box_name: "Content ",
    Statement: "This is a free response question. You can write here the question statement.",
    Question: "Question",
    Answer: "Answer",
    Feedback: "Feedback",
    FeedbackMsg:
      "Here you can provide some feedback about the answer. In order to disable this feature, turn it off in the toolbar.",
    TrueFeedbackMsg:
      "Here you can provide some feedback about the true answer. In order to disable this feature, turn it off in the toolbar.",
    FalseFeedbackMsg:
      "Here you can provide some feedback about the false answer. In order to disable this feature, turn it off in the toolbar.",
    ShowFeedback: "Show feedback msg.",
    Placeholder: "Type your answer here",
    PlaceholderEditor: "The student will type the answer here",
    TooMany: "You have introduced too many characters. The exercise will not be corrected.",
    TooFew: "Please enter at least the minimum required characters.",
    MinLength: "Minimum Length",
    MaxLength: "Maximum Length",
    MaxInput: "Max characters",
    Characters: "Ignore case and special characters",
    Correct: "Exact answer",
    Config: "Configuration",
    FeedbackColor: "Color",
    notCount: "This exercise does not add points",
    InputAppearance: "Answer Field Appearance",
    InputBackground: "Background Color",
    InputHeight: "Field Height",
    InputTypography: "Text Style",
    InputFont: "Font Family",
    InputFontSize: "Font Size",
    InputTextColor: "Text Color",
    InputBorder: "Border Style",
    InputBorderColor: "Border Color",
    InputBorderWidth: "Border Width",
    InputBorderRadius: "Corner Roundness",
    CheckAnswerText: "Check Answer Button Text",
    TryAgainText: "Try Again Button Text",
    SeeAnswerText: "See Answer Button Text",
    ButtonStyle: "Button Style",
    ButtonBackground: "Button Background Color",
    ButtonTextColor: "Button Text Color",
    ButtonBorderColor: "Button Border Color",
    ButtonBorderWidth: "Button Border Width",
    ButtonBorderRadius: "Button Border Radius",
    ButtonPadding: "Button Padding",
    ButtonFontSize: "Button Font Size",
    ButtonFontWeight: "Button Font Weight",
    ButtonHoverBackground: "Button Hover Background Color",
    tryAgain: "Try Again",
    checkAnswer: "Check Answer",
    seeAnswer: "See Answer",
  },
};
